import { CompareCredit } from '../../../types/compare-credit'
import { getAdvertorialAttributeByCard } from '../../utils'

export const AttributeRendererWithSlugV2 = (data: {
  referencedCards: null | Record<string, CompareCredit.Entity>
}) => {
  const render: React.FC<{
    value: {
      attribute: string
      slug: string
      bonusRewards: string
    }
  }> = ({ value }) => {
    const { referencedCards } = data
    const cardSlug = value.slug
    const card = referencedCards
      ? (referencedCards[cardSlug] as CompareCredit.FormattedCard)
      : null

    return card ? getAdvertorialAttributeByCard({ card, ...value }) : <></>
  }
  return render
}
